// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const traingApi = baseApi.injectEndpoints({
  reducerPath: "traingApi",
  endpoints: (builder) => ({
    getAllCategory: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/training-category?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addCategory: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/training-category",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateCategory: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/training-category/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteCategory: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/training-category/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllTranings: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/training?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addTraining: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/training",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateTraining: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/training/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteTraining: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/training/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllBatches: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/training-batch?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addBatch: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/training-batch",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateBatch: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/training-batch/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteBatch: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/training-batch/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllClasses: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/class?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addClass: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/class",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateClass: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/class/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteClass: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/class/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllServiceType: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/service-type?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addServiceType: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/service-type",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateServiceType: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/service-type/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteServiceType: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/service-type/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllSpecialities: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `admin/speciality?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addSpecialities: builder.mutation({
      query: ({data}) => {
        return {
          url: "admin/speciality",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateSpecialities: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/speciality/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteSpecialities: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/speciality/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetAllTraningsQuery,
  useAddTrainingMutation,
  useUpdateTrainingMutation,
  useDeleteTrainingMutation,
  useGetAllBatchesQuery,
  useAddBatchMutation,
  useUpdateBatchMutation,
  useDeleteBatchMutation,
  useGetAllClassesQuery,
  useAddClassMutation,
  useUpdateClassMutation,
  useDeleteClassMutation,
  useGetAllServiceTypeQuery,
  useAddServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,  
  useGetAllSpecialitiesQuery,
  useAddSpecialitiesMutation,
  useUpdateSpecialitiesMutation,
  useDeleteSpecialitiesMutation,
} = traingApi;
